import React from 'react';
import {JAVASCRIPT_VOID} from 'constants/config';

interface IPlayerInfoProps {
  title: string;
  nickname: string;
  readCnt: string;
  onClickOpenChat: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

/**
 * 플레이어 정보 컴포넌트
 */

const PlayerInfo = ({
  title,
  nickname,
  readCnt,
  onClickOpenChat,
}: IPlayerInfoProps) => {
  return (
    <>
      <div className='player_info' style={{display: 'block'}}>
        <div className='tuneout'>
          <p>사전 협의되지 않은 탐방 및 재송출은 정중히 사절합니다.</p>
        </div>
      </div>
      <div className='smode_chatbtn'>
        <a href={JAVASCRIPT_VOID} onClick={onClickOpenChat}>
          채팅창 열기
        </a>
      </div>
      <div className='title' style={{display: 'block'}}>
        <div>
          <span>{nickname}</span>
          <span>
            <em></em>
            {readCnt}
          </span>
        </div>
        <h1>{title}</h1>
        {/* <a href="#n" style={{display: "block;"}}>afreecatv</a> */}
      </div>
    </>
  );
};

PlayerInfo.defaultProps = {
  title: '',
  nickname: '',
  readCnt: '0',
};

export default PlayerInfo;
